var map = {
	"./2021/10-17/architecture_first_attempt.png": 115,
	"./2021/10-17/architecture_second_attempt.png": 545,
	"./2022/11-25/scooby_doo.gif": 268,
	"./2023/11-08/new_about_me.png": 311,
	"./2023/11-08/old_about_me.png": 152,
	"./2023/11-08/share_button.png": 124,
	"./2023/11-08/share_button_preview.png": 518,
	"./2024/haruka_sawamura.png": 178,
	"./2024/rock_paper_invaders_background.png": 750,
	"./2024/untitled_2024_01_07.png": 861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 720;